// extracted by mini-css-extract-plugin
export default {"checkbox":"Checkbox_checkbox__RZVAP","input":"Checkbox_input__VGueh","indicator":"Checkbox_indicator__XRuZb","label":"Checkbox_label__mEL-z","disabled":"Checkbox_disabled__wz0bA"};